<mat-card appearance="outlined">
  <div class="card-header-container">
    <div class="card-header-container__img">
      <img
        [src]="accessoryImg"
        [alt]="accessory?.name"
        defaultImg>
      </div>
      <mat-card-title class="card-header-container__box-title">{{accessory?.name}}</mat-card-title>
      <mat-card-subtitle class="card-header-container__box-description" [innerHtml]="accessory?.description"></mat-card-subtitle>
    </div>
    <mat-card-content class="accessory-box-content">
      <form [formGroup]="form">
        @if (accessory.price_source == 'confColors') {
          <div>
            @if (accessory.show_colors) {
              <button mat-raised-button
              (click)="openModalColors(accessory)">{{ 'ACCESSORY|Kolory' | translate }}</button>
            }
            @if (accessory.price_source == 'confColors' && accessory.selectedWood?.name) {
              <span>{{ 'WINDOW|Rodzaj drewna' | translate }}:
                @if (accessory.price_source == 'confColors') {
                  <b
                  >{{ accessory.selectedWood?.name }}</b>
                }
                <br />
              </span>
            }
            @if (accessory.price_source == 'confColors' && accessory.selectedColor.outer?.name) {
              <span
                >{{ 'WINDOW|Kolor zewn.' | translate }}:
                @if (accessory.price_source == 'confColors') {
                  <b
                  >{{ accessory.selectedColor.outer?.name }}</b>
                }
                <br />
              </span>
            }
            @if (accessory.price_source == 'confColors' && accessory.selectedColor.inner?.name) {
              <span
                >{{ 'WINDOW|Kolor wewn.' | translate }}:
                @if (accessory.price_source == 'confColors') {
                  <b
                  >{{ accessory.selectedColor.inner?.name }}</b>
                }
                <br />
              </span>
            }
            @if (accessory.price_source == 'confColors' && accessory.selectedColor.core?.name && showCoreColorInAdditionalProfilesAndAccessories) {
              <span
                >{{ 'WINDOW|Kolor bazy' | translate }}:
                @if (accessory.price_source == 'confColors') {
                  <b
                  >{{ accessory.selectedColor.core?.name }}</b>
                }
                <br />
              </span>
            }
          </div>
        }

        @if (accessory.price_source == 'colors') {
          <div>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'ACCESSORY|Kolor' | translate }}</mat-label>
              <mat-select [disabled]="isAccessoryColorFieldDisabled()" formControlName="selectedColor">
                @for (color of getAccessoryColors(accessory); track color) {
                  <mat-option (onSelectionChange)="setAccessoryColorPrice(color, $event)"
                    [value]="color.id">
                    {{color.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        @if (accessory.show_colors && accessory.price_source == 'table') {
          <div
            >
            <mat-select formControlName="colorOptions" (selectionChange)="setColorOptionsPrice(accessory)">
              @if (accessory.no_price || (!accessory.no_price && accessory.price_white)) {
                <mat-option value="white"
                  >
                  {{ 'COLOR|Biały' | translate }}
                </mat-option>
              }
              @if (accessory.no_price || (!accessory.no_price && accessory.price_white_colour)) {
                <mat-option value="color-white"
                  >
                  {{ 'ACCESSORY|Kolor' | translate }}/{{ 'COLOR|Biały' | translate }}
                </mat-option>
              }
              @if (accessory.no_price || (!accessory.no_price && accessory.price_colour_colour)) {
                <mat-option value="color-color"
                  >
                  {{ 'ACCESSORY|Kolor' | translate }}/{{ 'ACCESSORY|Kolor' | translate }}
                </mat-option>
              }
              @if (accessory.no_price || (!accessory.no_price && accessory.price_ral)) {
                <mat-option value="ral"
                  >
                  {{ 'COLOR|RAL' | translate }}
                </mat-option>
              }
            </mat-select>
          </div>
        }
        @if (spaceSelect.length > 0) {
          <div>
            <mat-label>{{ 'ACCESSORY|Pozycja' | translate }}</mat-label>
            <mat-select formControlName="spaceId" (selectionChange)="setAccessorySpace(accessory)">
              @for (space of spaceSelect; track space) {
                <mat-option [value]="space.id">
                  {{space.name}}
                </mat-option>
              }
            </mat-select>
          </div>
        }
        @if (accessory.type != 'dowel_hole') {
          <mat-form-field appearance="outline">
            <input matInput type="number" min="1"
              [placeholder]="'ACCESSORY|Ilość' | translate"
              formControlName="count"
              iccNumberInput>
            </mat-form-field>
          }
          @if (accessory.price_type == '1') {
            <mat-form-field appearance="outline">
              <input matInput iccDimensionInput type="number" min="0.01" value=""
                [placeholder]="'ACCESSORY|Szer.' | translate" step="0.01"
                formControlName="amount_width">
                <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
              </mat-form-field>
            }
            @if ((accessory.type == 'ventilator' || accessory.type == 'ventilator_hole') && config().IccConfig.Configurators.ventilatorPositioning) {
              <mat-form-field appearance="outline">
                <input matInput iccDimensionInput type="number" formControlName="position"
                  (focus)="focused = true" (blur)="focused = false"
                  [placeholder]="'ACCESSORY|Pozycja w' | translate ">
                  @if (!focused) {
                    <input matInput iccDimensionInput type="number"
                      min="{{topFrameProfile?.minVentilatorSpace + accessory.width / 2}}"
                      max="{{sash?.rWidth - topFrameProfile?.minVentilatorSpace - accessory.width / 2}}"
                      value="{{sash?.rWidth / 2}}" formControlName="position">
                    }
                    <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
                  </mat-form-field>
                }
                @if (accessory.price_type == '1') {
                  <mat-form-field appearance="outline">
                    <input matInput iccDimensionInput type="number" min="0.01" value="" step="0.01"
                      formControlName="amount_height"
                      [placeholder]="accessory.type == 'windowsill' ? ('ACCESSORY|Głęb.' | translate) : ('ACCESSORY|Wys.' | translate) ">
                      <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
                    </mat-form-field>
                  }
                  @if (accessory.price_type == '2' && (forIt != 'side' && !(forIt == 'sash' && accessory.type == 'renson'))) {
                    <mat-form-field appearance="outline">
                      <input matInput iccDimensionInput type="number" min="0.01" value="" step="0.01"
                        formControlName="amount"
                        [disabled]="accessory.blockAmountChange"
                        [placeholder]="'ACCESSORY|Dł.' | translate">
                        <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
                      </mat-form-field>
                    }


                    <!-- TODO <span ng-if="access.price_type == 0 && !access.no_price && !maccessory.noPrice">{{ 'CONFIGURATOR|Cena' | translate }}:
                    <b>{{access| accessoryPriceOne:((access.show_colors && access.price_source == 'table') ? access.colorOptions : access.selectedColor) | currency:state.offers[0].doc.currency}}/<span ng-bind-html="::access.price_type|formatUnit"></span></b></span>
                    <span ng-if="access.price_type != 0 && !access.no_price && !maccessory.noPrice">{{ 'CONFIGURATOR|Cena' | translate }}:
                      <b>{{$root.user.dimension_unit != 'mm' ? '~' : ''}}{{access| accessoryPriceOne:((access.show_colors && access.price_source == 'table') ? access.colorOptions : access.selectedColor) | unitm:0:0:3 | currency:state.offers[0].doc.currency}}/<span ng-bind-html="::access.price_type|formatUnit"></span></b></span>
                      <span ng-if="access.no_price || maccessory.noPrice">{{ 'CONFIGURATOR|Cena' | translate }}:
                        <b>{{ 'CONFIGURATOR|Do wyceny' | translate }}</b>
                      </span> -->
                    </form>
                  </mat-card-content>
                  <mat-card-actions class="accessory-box-actions">
                    @if (!hiddenPrice) {
                      <h4>{{ 'CONFIGURATOR|Cena' | translate }}:
                        @if (getPrice(true) && getPrice(true) !== getPrice()) {
                          <s>{{getPrice(true) | currency : currency}}</s>
                        }
                      {{ (getPrice() | currency : currency) || ('CONFIGURATOR|Do wyceny' | translate) }}</h4>
                    }
                    <button mat-raised-button color="primary" (click)="add()">{{ 'INTERFACE|Dodaj' | translate }}</button>
                  </mat-card-actions>
                </mat-card>
